import React from "react";
import {
  Button,
  Divider,
  FormControlLabel,
  Grid,
  Typography,
} from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ImageDefault from "assets/images/DefaultImage/defalut-publish-doc.jpg";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

export default function FileAttach({
  sFilePathCover,
  sDocumentName,
  sDocDate,
  sFilePath,
}) {
  const handleOpenFile = (sFilePath) => {
    if (sFilePath) {
      let sUrl = process.env.REACT_APP_API_URL + "/" + sFilePath;
      window.open(sUrl, "_blank", "noreferrer");
    }
  };
  return (
    <Grid item container xs={12}>
      <Grid item md={3} xs={12}>
        <img
          alt=""
          src={
            sFilePathCover
              ? process.env.REACT_APP_API_URL + "/" + sFilePathCover
              : ImageDefault
          }
          width="150"
          style={{ cursor: sFilePathCover ? "pointer" : "default" }}
          onClick={() => handleOpenFile(sFilePathCover)}
        />
      </Grid>
      <Grid item md={9} xs={12}>
        <Typography sx={{ fontSize: "20px", fontWeight: "bold" }}>
          {sDocumentName}
        </Typography>
        <Grid item xs={12} mb={1}>
          <Divider />
        </Grid>

        <FormControlLabel
          sx={{ marginLeft: "0px", cursor: "default" }}
          control={<CalendarMonthIcon sx={{ color: "#5077be" }} />}
          label={<span style={{ color: "#5077be" }}>&nbsp;{sDocDate}</span>}
        />
        <Grid item xs={12} mt={1}>
          <Divider />
        </Grid>

        <Typography
          sx={{ color: "blue", marginTop: "2rem", marginBottom: "1rem" }}
        >
          <Button
            variant="contained"
            sx={{
              bgcolor: "#758290",
              color: "white",
              borderRadius: "20px",
            }}
            onClick={() => handleOpenFile(sFilePath)}
            endIcon={<ArrowForwardIosIcon />}
          >
            อ่านเพิ่มเติม
          </Button>
        </Typography>
      </Grid>
      <Grid item xs={12} marginBottom={"10px"}>
        <Divider />
      </Grid>
    </Grid>
  );
}
